import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

const shuffle = (array) => {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
};

function Home() {
  const [songs, setSongs] = useState([]);
  const [lastAdded, setLastAdded] = useState([]);
  const [trending, setTrending] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState(''); // Sıralama ölçütü
  const [sortOrder, setSortOrder] = useState(''); // Sıralama düzeni (azalan/artan)

  const [totalPhonks, setTotalPhonks] = useState(0);

  useEffect(() => {
    fetchSongs();
    fetchTotalPhonks();
  }, []);

  const fetchTotalPhonks = () => {
    fetch('https://backend.viralphonks.com:443/songs/count')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setTotalPhonks(data.totalSongs);
      })
      .catch((error) => console.error('Error fetching total phonks:', error));
  };

  const fetchSongs = (query = '', sort = '', order = 'desc') => {
    let url = `https://backend.viralphonks.com:443/songs?search=${query}`;
    if (sort) {
      url += `&sortBy=${sort}&sortOrder=${order}`;
    }
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (sort) { // Eğer sıralama yapılıyorsa karıştırma
          setSongs(data);
        } else {
          setSongs(shuffle(data));
        }
        if (!query && !sort) { // Sadece arama veya sıralama yoksa lastAdded ve trending güncellenir
            const sortedByDate = [...data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setLastAdded(sortedByDate.slice(0, 5));
            const trendingSongs = data.filter(song => song.is_trending);
            setTrending(trendingSongs.slice(0, 5));
        }
      })
      .catch((error) => console.error('Error fetching songs:', error));
  };

  const handleSearch = (e) => {
      e.preventDefault();
      fetchSongs(searchTerm, sortBy, sortOrder);
  }

  const handleSortChange = (e) => {
    const newSortBy = e.target.value;
    setSortBy(newSortBy);
    fetchSongs(searchTerm, newSortBy, newSortBy === '' ? '' : sortOrder);
  };

  const handleSortOrderChange = (e) => {
    const newSortOrder = e.target.value;
    setSortOrder(newSortOrder);
    fetchSongs(searchTerm, sortBy, newSortOrder);
  };

  const handleListenClick = (songId) => {
    fetch(`https://backend.viralphonks.com:443/songs/${songId}/click`, {
      method: 'PUT',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        // Tıklanma sayısını güncelledikten sonra şarkının tıklanma sayısını yerel olarak güncelle
        setSongs(prevSongs =>
          prevSongs.map(song =>
            song.id === songId ? { ...song, click_count: (song.click_count || 0) + 1 } : song
          )
        );
      })
      .catch(error => console.error('Error incrementing click count:', error));
  };

  const handleSidebarClick = (songId) => {
    const songCard = document.getElementById(`song-card-${songId}`);
    if (songCard) {
      songCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      songCard.classList.add('highlight-scroll');
      setTimeout(() => {
        songCard.classList.remove('highlight-scroll');
      }, 1500); // Animation duration is 1.5s
    }
  };

  const Song = ({ song }) => {
    const [selectedLink, setSelectedLink] = useState(song.youtube_link || song.slowed_link || song.superslowed_link || '');

    const handleVersionChange = (e) => {
      setSelectedLink(e.target.value);
    };

    return (
      <div className="song-card" id={`song-card-${song.id}`}>
        {song.is_new === 1 && <div className="new-tag">NEW</div>}
        <img src={song.cover_image_url} alt={song.title} style={{width: "100%", height: "auto"}}/>
        <h2>{song.title}</h2>
        <p>{song.artist}</p>
        <p>Clicks: {song.click_count || 0}</p> {/* Tıklanma sayısını göster */}
        <div className="song-actions">
          <select onChange={handleVersionChange} value={selectedLink}>
            <option value={song.youtube_link || ''} disabled={!song.youtube_link} style={{textDecoration: !song.youtube_link ? 'line-through' : 'none'}}>Normal</option>
            <option value={song.slowed_link || ''} disabled={!song.slowed_link} style={{textDecoration: !song.slowed_link ? 'line-through' : 'none'}}>Slowed</option>
            <option value={song.superslowed_link || ''} disabled={!song.superslowed_link} style={{textDecoration: !song.superslowed_link ? 'line-through' : 'none'}}>Super Slowed</option>
          </select>
          <a href={selectedLink} target="_blank" rel="noopener noreferrer" onClick={() => handleListenClick(song.id)}>
            Listen
          </a>
          </div>
      </div>
    );
  };

  return (
    <div className="App">
      <div className="sidebar">
        <div className="sidebar-section">
          <ul className="sidebar-nav-list">
            <li><Link to="/about">About</Link></li>
            <li><button disabled className="sidebar-button">Phonk Send</button></li>
          </ul>
        </div>
        <div className="sidebar-section">
          <h3>Last Added</h3>
          <ul>
            {lastAdded.map(song => (
              <li key={`last-${song.id}`} onClick={() => handleSidebarClick(song.id)} style={{cursor: 'pointer'}}>
                <img src={song.cover_image_url} alt={song.title} className="sidebar-cover-img"/>
                {song.title}
              </li>
            ))}
          </ul>
        </div>
        <div className="sidebar-section">
          <h3>Trending</h3>
          <ul>
            {trending.map(song => (
              <li key={`trend-${song.id}`} onClick={() => handleSidebarClick(song.id)} style={{cursor: 'pointer'}}>
                <img src={song.cover_image_url} alt={song.title} className="sidebar-cover-img"/>
                {song.title}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="main-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>Viral Phonks <span style={{ fontSize: '0.5em' }}>Total Phonks: {totalPhonks}</span></h1>
          <Link to="/login" className="login-button">Login</Link>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px' }}>
              <input type="text" placeholder="Search for a song..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
              <button type="submit">Search</button>
          </form>
          <div style={{ display: 'flex', gap: '10px' }}>
            <select onChange={handleSortChange} value={sortBy}>
              <option value="">Sort By</option>
              <option value="click_count">Clicks</option>
              <option value="created_at">Date Added</option>
            </select>
            <select onChange={handleSortOrderChange} value={sortOrder} disabled={sortBy === ''}>
              <option value="desc">Descending</option>
              <option value="asc">Ascending</option>
            </select>
          </div>
        </div>
        <div className="song-list">
          {songs.map((song) => (
            <Song key={song.id} song={song} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
